import React, { useEffect, useState } from 'react';
import {
  Grid, IconButton, makeStyles, Paper, Toolbar, Typography, Snackbar
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Map from '../map/Map';
import ShareFilter from './ShareFilter';
import { useTranslation } from '../LocalizationProvider';
import { addItemToArray, api_call, console_log, empty, generateSharedFullUrl, generateSharedUrlId, get_utc_timestamp, isMobile, returnMobileApp } from '../helpers/untils';
import copy from 'copy-to-clipboard';
import { REDIRECT_APP_TIMESTAMP, SHARED_LINK_TEXT_KEY, SHARE_RESERVATION_URL } from '../config/constant';
import { getTuroSummaryFirstLastWord } from '../helpers/misc';
import ShareReservationFilter from './ShareReservationFilter';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  title: {
    ...theme.typography.title,
  },
  sidebar: {
    position: 'absolute',
    left: 0,
    top: 0,
    margin: theme.spacing(1.5),
    width: theme.dimensions.drawerWidthDesktop,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      margin: 0,
    },
  },
  formControlLabel: {
    height: '100%',
    width: '100%',
    paddingRight: theme.spacing(1),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  shareFilterContainer: {
    flex: 1,
    padding: theme.spacing(2),
    minWidth: '400px',
    maxHeight: 'calc(100vh - 110px)',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1),
      minWidth: '0px',
      maxHeight: 'calc(100vh - 90px)',
    },
  },
  sliderContainer: {
    padding: theme.spacing(2),
  },
  mobileBlock: {
    display: 'none',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
}));

const ShareReservationPage = () => {
  const t = useTranslation();
  const classes = useStyles();
  const history = useHistory();

  const { id } = useParams();

  const [selectedDeviceId, setSelectedDeviceId] = useState(id);
  const [selectedDevice, setSelectedDevice] = useState();
  const [tripList, setTripList] = useState([]);
  const [trip, setTrip] = useState(null);

  const [shareUrl, setShareUrl] = useState("");
  const [pageData, setPageData] = useState(null);

  const [apiLoading, setApiLoading] = useState(false)

  const userId = useSelector((state) => state.session.user.id);

  useEffect(() => {
    if (selectedDeviceId) {
      loadPageData(selectedDeviceId)
    }
    // console.log("TIMEZONE_LIST:::", TIMEZONE_LIST)
  }, [selectedDeviceId])

  const loadPageData = async (deviceId) => {
    setSelectedDeviceId(deviceId);
    const url = `/api/get-share-trip-page-data/${deviceId}`
    const response = await api_call(url);
    if (response.ok) {
      const res = await response.json();
      const deviceCarSharingUrlRow = res?.deviceCarSharingUrlRow
      if (deviceCarSharingUrlRow) {
        setSelectedDevice(res.device)
        setPageData(res)
      } else {
        // showToast(`Invalid request!`)
        returnMobileApp(history);
      }
    } else {
      const errorObj = response
      const errorMessage = errorObj.message ?? errorObj.error ?? "Internal server error"
      showToast(errorMessage)
      returnMobileApp(history);
    }
  }

  const copyTextClipboard = () => {
    let clipboardText = SHARE_RESERVATION_URL // getTextForClipboard(shared_url, sharedTextTemplate)
    if (clipboardText) {
      //navigator.clipboard.writeText(clipboardText);
      copy(clipboardText);
      return true
    } else {
      return false
    }
  }

  const scrollDown = () => {
    var objDiv = document.getElementById("shareFilterContainer");
    objDiv.scrollTop = objDiv.scrollHeight;
  }

  const handleSubmit = async (form_data, applyScrollDown = true) => {
    ///////////////// copy to clipboard should be done first due to ios higher version ////////////////////////////////////////////////
    copyTextClipboard()
    /////////////////////////////////////////////////////////////////

    setApiLoading(true)
    const url = `/api/trip-access-links/updateSetting`;
    let response = await api_call(url, {
      method: 'POST',
      body: form_data,
    });

    setApiLoading(false)
    if (response.ok) {
      const responseObj = await response.json()
      console_log(`updateSetting responseObj:::`, responseObj)
      if (responseObj.id) {
        if (applyScrollDown) {
          setToastMessage("Saved successfully!") //setToastMessage("Link has been copied…")
          setSnackbarOpen(true);
          scrollDown()
        }
      } else {
        alert("Invalid request")
      }
    } else {
      let errorObj = response
      let errorMsg = errorObj['error'] ?? errorObj['message']
      if (errorMsg) {
        alert(errorMsg)
      } else {
        alert("Unknown error")
      }
    }
  }

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const showToast = (msg) => {
    setToastMessage(msg)
    setSnackbarOpen(true);
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token) {
      localStorage.setItem('m_token', token);
      localStorage.setItem('fromMobile', true);
    } else {
      localStorage.removeItem('fromMobile');
    }
  }, [])

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={snackbarOpen}
        onClose={() => { setSnackbarOpen(false) }}
        autoHideDuration={1500}
        message={toastMessage}
      />

      <Map />
      <div className={classes.sidebar}>
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <Paper elevation={3} square>
              <Toolbar disableGutters>
                <Grid container alignItems="center">
                  <Grid item>
                    <IconButton onClick={async () => {
                      returnMobileApp(history);
                    }}>
                      <ArrowBackIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs>
                    <Typography className={classes.share} color="primary">
                      Share Reservation Access
                    </Typography>
                  </Grid>
                </Grid>
              </Toolbar>
            </Paper>
          </Grid>
          <Grid item>
            <Paper elevation={3} className={classes.shareFilterContainer} id="shareFilterContainer" square>
              <ShareReservationFilter
                snackbarOpen={snackbarOpen}
                setSnackbarOpen={setSnackbarOpen}
                toastMessage={toastMessage}
                setToastMessage={setToastMessage}
                handleSubmit={handleSubmit}
                fullScreen
                showOnly
                selectedDeviceId={id}
                setSelectedDeviceId={setSelectedDeviceId}
                selectedDevice={selectedDevice}
                tripList={tripList}
                trip={trip}
                setTrip={setTrip}
                history={history}
                shareUrl={shareUrl}
                apiLoading={apiLoading}
                setApiLoading={setApiLoading}
                pageData={pageData}
                setPageData={setPageData}
                showToast={showToast}
                copyTextClipboard={copyTextClipboard}
              >
              </ShareReservationFilter>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default ShareReservationPage;
